import { get, patch, post, invokeApi, createAdditionalParams } from './index';

export const getSwapReinvestmentUserSetting = async (serviceId) => {
  const additionalParams = await createAdditionalParams();

  return invokeApi({}, `${serviceId}/swap_reinvestment_setting`, get, additionalParams);
};

export const createSwapReinvestmentUserSetting = async (serviceId, requestBody) => {
  const additionalParams = await createAdditionalParams();

  return invokeApi({}, `${serviceId}/swap_reinvestment_setting`, post, additionalParams, requestBody);
};

export const updateSwapReinvestmentUserSetting = async (serviceId, requestBody) => {
  const additionalParams = await createAdditionalParams();

  return invokeApi({}, `${serviceId}/swap_reinvestment_setting`, patch, additionalParams, requestBody);
};

export const updateSwapReinvestmentUserStatus = async (serviceId, requestBody) => {
  const additionalParams = await createAdditionalParams();

  return invokeApi({}, `${serviceId}/swap_reinvestment_setting/status`, patch, additionalParams, requestBody);
};
